<section class="cf-card">
  <h2 class="cf-card__title">{{ section.label }}</h2>

  <div class="cf-card__body">
    <div class="cf-grid">
      <app-company-field
        *ngFor="let field of visibleFields; trackBy: trackByControlName"
        [field]="field"
        [form]="form"
        [state]="stateFor(field)"
        [submitted]="submitted"
        [dataSource]="sourceFor(field)"
        [optionResolver]="resolverFor(field)"
        (underInputClick)="underInputClick.emit($event)"
        (editOptionClick)="editOptionClick.emit($event)"
      ></app-company-field>
    </div>
  </div>
</section>
